import {FormValuesProps} from "./NewFlowModal";

export const isFlowFormValid = (formValues: FormValuesProps) => {
    const errors = [];
    if(formValues.title.length < 3) {
        errors.push('Please type a meaningful title');
    }
    if(!formValues.flowTriggerId) {
        errors.push('Please select a trigger for this flow');
    }
    // if(!formValues.flowTypeId) {
    //     errors.push('Please select what type of flow you wish to create');
    // }
    // if(!formValues.distribution || formValues.distribution < 1 || formValues.distribution > 100) {
    //     errors.push('Distribution should be between 1 to 100 percent');
    // }
    return errors;
}